import {
  AlertTriangle,
  Anchor,
  ArrowUpFromLine,
  BarChart3,
  BookOpen,
  Boxes,
  Building2,
  Cable,
  ClipboardCheck,
  Cog,
  Construction,
  Cylinder,
  Download,
  Forklift,
  Gauge,
  Gift,
  GitCompare,
  GraduationCap,
  Hammer,
  HardHat,
  Layers,
  LayoutGrid,
  Library,
  Link,
  ListChecks,
  MoveUpRight,
  MoveVertical,
  Package,
  Pickaxe,
  Presentation,
  Route,
  Ruler,
  Scale,
  ScanSearch,
  Settings2,
  Shovel,
  Target,
  Tractor,
  TrafficCone,
  TrendingUp,
  Warehouse,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Professional Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: '300 Visual Training Pages', icon: BookOpen, featured: true },
  { label: 'Ready-to-Teach Training Resources', icon: Presentation, featured: true },
  { label: 'Forklift Equipment Fundamentals', icon: Forklift },
  { label: 'Material Handling Equipment', icon: Package },
  { label: 'Forklift Anatomy', icon: ScanSearch },
  { label: 'Mast and Lifting Components', icon: ArrowUpFromLine },
  { label: 'Load Stability Awareness', icon: Scale },
  { label: 'Warehouse Traffic', icon: Warehouse },
  { label: 'Excavator Fundamentals', icon: Shovel },
  { label: 'Excavator Anatomy', icon: Cog },
  { label: 'Hydraulic Component Awareness', icon: Gauge },
  { label: 'Excavator Attachments', icon: Wrench },
  { label: 'Excavation Worksite Recognition', icon: Pickaxe },
  { label: 'Bulldozer Anatomy', icon: Tractor },
  { label: 'Loader Components', icon: Settings2 },
  { label: 'Motor Grader References', icon: Ruler },
  { label: 'Machinery Comparisons', icon: GitCompare },
  { label: 'Construction Site Awareness', icon: Construction },
  { label: 'Crane Anatomy', icon: Anchor },
  { label: 'Boom and Hoist Components', icon: Link },
  { label: 'Rigging Equipment Recognition', icon: Cable },
  { label: 'Lifting-Site Awareness', icon: AlertTriangle },
  { label: 'Scissor Lifts', icon: Layers },
  { label: 'Articulating Boom Lifts', icon: MoveUpRight },
  { label: 'Telescopic Boom Lifts', icon: MoveVertical },
  { label: 'Elevated Workplace Scenarios', icon: Building2 },
  { label: 'Road Rollers', icon: Cylinder },
  { label: 'Compaction Equipment', icon: Hammer },
  { label: 'Asphalt Pavers', icon: Route },
  { label: 'Roadwork Hazard Awareness', icon: TrafficCone },
  { label: 'Professional Equipment Diagrams', icon: LayoutGrid },
  { label: 'Realistic Workplace Scenarios', icon: HardHat },
  { label: 'Machinery Identification Exercises', icon: Target },
  { label: 'Instructor Teaching Resources', icon: GraduationCap },
  { label: 'Classroom Knowledge Checks', icon: ListChecks },
  { label: 'Student Assessment Tools', icon: ClipboardCheck },
  { label: 'Beginner-to-Advanced Adaptations', icon: BarChart3 },
  { label: 'Training Progression Resources', icon: TrendingUp },
  { label: '5 Professional Instructor Bonuses', icon: Gift },
  { label: 'Immediate Digital Access', icon: Download },
]
